import type { ApiResponse } from '@farmfree/common/types/apiResponse'
import type { OrderPenArchive } from '@farmfree/common/types/order/orderPenArchive'

export function createArchivedOrderService() {
  return {
    async getModified(companyId: string, since: number): Promise<ApiResponse<OrderPenArchive[]>> {
      return {
        isSuccess: true,
        data: [],
        message: '',
      }
    },

    async getDeleted(companyId: string): Promise<ApiResponse<string[]>> {
      return {
        isSuccess: true,
        data: [],
        message: '',
      }
    },
  }
}
